import React from 'react'

import "./style.css"

const AboutScreen = () => {
  return (
    <div id="AboutMainDiv">
            <br/>
            <div class="title">EDUCATION</div>
            <br/>
            <br/>
            <div style={{maxWidth: 900,}}>
                <div class="About-Course">
                    Bachelor Of Technology In Information Technology
                </div>
                <div class="About-Course-Duration">
                    2021-2025 | Alliance University
                </div>
                <div class="About-Course-Description">
                    Currently pursuing Bachelor Of Technology In Information Technology At Alliance University
                </div>
                <div class="About-Course-Location">
                    BANGLORE, KARNATAKA,
                </div>
                <br/>
                <br/>
                <div class="About-Course">
                    Pre-University In [PCMB]
                </div>
                <div class="About-Course-Duration">
                    2019-2020 | VISHWACHETANA PU COLLEGE\n2020-2021 | DON BOSCO PU COLLEGE
                </div>
                <div class="About-Course-Description">
                    Pursued My PRE-UNVIVERSITY Education In [PCMB] stream At VISHWACHETANA PU COLLEGE In 1ST PU And At DON BOSCO PU COLLEGE In 2ND PU
                </div>
                <div class="About-Course-Location">
                    DAVANGERE KARNATAKA , CHITRADURAGA KARANATAKA
                </div>
                <br/>
                <br/>
                <div class="About-Course">
                    Schooling
                </div>
                <div class="About-Course-Duration">
                    2009-2019 | SRI BASAVA INTERNATIONAL SCHOOL
                </div>
                <div class="About-Course-Description">
                    Pursued My High School Education At Sri Basava International School
                </div>
                <div class="About-Course-Location">
                    CHANNAGIRI, DAVANAGERE, KARNATAKA,
                </div>
                <br/>
                <br/>
    
    
            </div>
            <br/>
        </div>
    
  );
}

export default AboutScreen